import { ConfigEditorProviders } from "./Providers";
import { ConfigEditorRouter } from "./Router";

export const ConfigEditor = () => {
  return (
    <ConfigEditorProviders>
      <ConfigEditorRouter />
    </ConfigEditorProviders>
  );
};
